export default __webpack_public_path__ + "static/media/0000..0001.24b5d4fa.png";